import {isMediaString, type MediaString} from '@wandb/weave/common/types/media';

import {
  RunValueSuggestionsPaginatedDocument,
  type RunValueSuggestionsPaginatedQuery,
} from '../../generated/graphql';
import * as Run from '../../util/runs';
import {makeInfiniteSelectField} from './InfiniteSelectField';

/**
 * Value field for a run filter row, backed by `project.runFieldValues`.
 */
export const FilterSimpleValueSelectField =
  makeInfiniteSelectField<RunValueSuggestionsPaginatedQuery>({
    label: 'Value',
    placeholder: 'Select a value',
    searchPlaceholder: 'Search values',
    extractItems: data =>
      data?.project?.runFieldValues?.edges
        .filter(edge => {
          // Allow null values through - they'll display as 'null'
          if (edge.node.value == null) {
            return true;
          }
          try {
            const parsedValue = JSON.parse(edge.node.value);
            const valueType = parsedValue?._type;
            // Since media types aren't simple values, we just want to enable filtering by null/non-null for now. So filter out
            // media values.
            return !isMediaString(valueType as MediaString);
          } catch (e) {
            // in case of JSON parse error, we don't want to show the value
            return false;
          }
        })
        .map(edge => Run.displayValue(edge.node.value, 'null')) ?? [],
    extractPageInfo: data => data?.project?.runFieldValues?.pageInfo ?? {},
    query: RunValueSuggestionsPaginatedDocument,
  });
